import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum SortDirection {
    ascending = "bfdd96e4-fcc3-44d8-b21a-d4a4a12bde69",
    descending = "d8368646-35be-48ec-83f2-c20d039688a8",
}

export type SortConfigurationLineItem = {
    // columnId: Uuid;
    columnId: string;
    direction: SortDirection;
};

export type SortConfiguration = {
    revisionId: Uuid;
    lineItems: Array<SortConfigurationLineItem>;
};

export function sortDirectionToDisplayName(sortDirection: SortDirection): string {
    switch (sortDirection) {
        case SortDirection.ascending: {
            return "Ascending";
        }
        case SortDirection.descending: {
            return "Descending";
        }
        default: {
            console.error("Invalid sortDirection", sortDirection);
            // throw new Error("Invalid sortDirection");
            return "Unknown";
        }
    }
}
